let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("ffQaD"), load("kvRbA"), load("ad2ge")]).then(() => parcelRequire('fsX0a'));